export default __webpack_public_path__ + "static/media/Snd_TryG.28128222.mp3";